import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, of, switchMap, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyAuthGuard implements CanActivate {
  constructor(
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const redirectOnFailUrl = this.router.createUrlTree(['/dashboard']);
    const companyId = route.paramMap.get('companyId');

    if (!companyId) {
      return of(redirectOnFailUrl);
    }

    if (this.authService.getCurrentCompanyId() === companyId) {
      return of(true);
    }

    return this.userService.getUserCompanyById(+companyId).pipe(
      switchMap((company) => {
        if (company?.oidcProviders?.length) {
          // company has OIDC provider, redirect to OIDC provider login page
          return of(this.router.createUrlTree(['/dashboard', 'auth'], { queryParams: { companyId } }));
        }

        return this.authService.employeeSignIn(companyId).pipe(
          tap(() => {
            this.authService.setCurrentCompany(companyId);
          }),
          map(() => true),
          catchError(() => {
            return of(redirectOnFailUrl);
          })
        );
      })
    );

  }
}
